import { render, staticRenderFns } from "./GrupoUsuarioEditar.vue?vue&type=template&id=82564ec6&"
import script from "./GrupoUsuarioEditar.vue?vue&type=script&lang=js&"
export * from "./GrupoUsuarioEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports